const translation = {

    // LOGIN LOGOUT
    'logout_ask': '¿Seguro que deseas cerrar sesión y salir?',
    'logout_confirmButtonText': 'Finalizar sesión',
    'logout_cancelButtonText': 'Cancelar',
    'logout_title': '¡Hasta pronto!',
    'logout_logout': 'Tu sesión ha sido terminada.',
    'Full Name': 'Nombre completo',
    'Company': 'Compañía',
    'Title': 'Título',
    'Email Address': 'Correo electrónico',
    'Phone Number': 'Número de teléfono',
    'Country': 'País',
    'Select a country': 'Selecciona un país',
    'Preferred Contact Method': 'Método de contacto preferido',
    'Select a Contact Method': 'Selecciona un método de contacto',
    'How can we help?': '¿Cómo podemos ayudarte?',
    'Select a Connection Type': 'Selecciona un tipo de conexión',
    'Select a Bridgerocks Area': 'Selecciona un área de Bridgerocks',
    'Bridgerocks Area': 'Área de Bridgerocks',
    'Investor Profile': 'Perfil de inversor',
    'Select an Investor Profile': 'Selecciona un perfil de inversor',
    'Select an Investment Interest': 'Selecciona un interés de inversión',
    'Capital Range': 'Rango de capital',
    'Select a Capital Range': 'Selecciona un rango de capital',
    'Investment Timeframe': 'Plazo de inversión',
    'Select a Timeframe': 'Selecciona un plazo de inversión',

    'Properties': 'Propiedades',
    'Ventures': 'Empresas',
    'What we do': 'Lo que hacemos',
    'Reyrock Studio': 'Reyrock Studio',
    'studio': 'estudio',

    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',
    
    'min_read': 'minutos de lectura',
    'Corporate': 'Corporativo',
    'Not found': 'No encontrado',
    'The article or page you are looking for could not be found.': 'El artículo o la página que estás buscando no se pudo encontrar.',

    'i_agree_to_the': 'Acepto la',
    '_and_': 'y los',

    'General Inquiry': 'Consulta general',
    'Investment & Capital': 'Inversión y capital',
    'Real Estate & Hospitality': 'Bienes raíces y hospitalidad',
    'Strategic Partnership or Joint Venture': 'Alianza estratégica o empresa conjunta',
    'Technology & Venture Opportunities': 'Tecnología y oportunidades de negocio',
    'Land or Property Submission': 'Presentación de terreno o propiedad',
    'Professional Services or Supplier Introduction': 'Servicios profesionales o presentación de proveedor',
    'Media, Institutional or Community Inquiry': 'Consulta de medios, institucional o comunitaria',
    'Careers & Talent': 'Carreras y talento',
    'Existing Relationship or Project Follow-Up': 'Relación existente o seguimiento de proyecto',
    'General Corporate Inquiry': 'Consulta corporativa general',
    'Other': 'Otro',

    'Bridgerocks Group': 'Grupo Bridgerocks',
    'Bridgerocks Corporate Management & Operations': 'Gestión corporativa y operaciones de Bridgerocks',
    'Reyrock Properties': 'Reyrock Properties',
    'Reyrock Talents': 'Reyrock Talents',
    'Reyrock Ventures': 'Reyrock Ventures',
    'Not sure — please direct my inquiry': 'No estoy seguro — por favor dirijan mi consulta',

    'Connect With Us': 'Conecta con nosotros',

    'How can we help you?': '¿Cómo podemos ayudarte?',
    'I agree to the Privacy Policy.': 'Acepto la Política de privacidad.',

    'Management': 'Gestión',
    'Talent': 'Talento',
    'Reyrock': 'Reyrock',


    // showRealEstateFields
    'Real Estate Interest': 'Interés en bienes raíces',


    // CONTACT LEAD
    'contact_lead': 'Por favor, llena el siguiente formulario para ponerte en contacto con nosotros',

    // MINOR DETAILS
    'telefono_celular': 'Teléfono celular',
    'created': 'Fecha de creación',
    'modified': 'Fecha de última edición',

    // BRDIGEROCKS WORLD

    // HOME
    'building the future': 'CONSTRUYENDO EL FUTURO',
    'home': 'Inicio',
    'about': 'Acerca de',
    'services': 'Servicios',
    'insights': 'Perspectivas',
    'fundation': 'Fundamentos',
    'contact': 'Contacto',
    'projects': 'Proyectos',
    'manifest': 'Manifiesto',
    'contact us': 'Contáctanos',
    'who we are': 'Quiénes somos',
    'learn more': 'Saber más',
    'what we solve': 'Lo que solucionamos',
    'why now': '¿Por qué ahora?',
    'why now?': '¿Por qué ahora?',
    'latest insights': 'Últimas perspectivas',
    'read more': 'Leer más',
    'read article': 'Leer artículo',
    'close': 'Cerrar',
    'privacy policy': 'Política de privacidad',
    'terms of service': 'Términos de servicio',
    'site map': 'Mapa del sitio',
    'page': 'Página',
    'our team': 'Nuestro equipo',
    'view all articles': 'Ver todos los artículos',
    'explore all projects': 'Explorar todos los proyectos',
    'featured projects': 'Proyectos destacados',
    'view project': 'Ver proyecto',
    'get in touch': 'Contáctanos',
    'email': 'Correo electrónico',
    'phone': 'Teléfono',
    'address': 'Dirección',
    'headquarters': 'Oficinas centrales',
    'business hours': 'Horario de atención',
    'send message': 'Enviar mensaje',
    'message sent': 'Mensaje enviado',
    'BRIDGE TO A WORLD OF OPPORTUNITIES': 'Puente hacia un mundo de oportunidades',
    'company': 'Compañía',
    'vision': 'Visión',
    'our ecosystem': 'Nuestro ecosistema',
    'advisory': 'Asesoría',
    'capital': 'Capital',
    'corporate services': 'Servicios corporativos',
    'venture creation': 'Creación de empresas',
    'property innovation': 'Innovación inmobiliaria',
    'connect': 'Conectar',
    'all rights reserved': 'Todos los derechos reservados',
    'built for visionaries': 'Hecho para visionarios',
    'bridgerocks world functions': 'Funciones De Bridgerocks World',

    'built on the r.o.c.k.s. framework': 'Construido en el entorno R.O.C.K.S. FRAMEWORK',
    'resources. opportunities. knowledge. strategies & services.': 'Recursos. Oportunidades. Conocimiento (Knowledge). Estrategias y servicios. (Strategies and Services).',
    'this proprietary model ensures that every idea receives': 'Este modelo propietario garantiza que cada idea reciba',
    'resources': 'Recursos',
    'capital, infrastructure, systems': 'capital, infraestructura, sistemas',
    'opportunities': 'Oportunidades',
    'incubation, venture creation, real estate, talent development': 'incubación, creación de empresas, bienes raíces, desarrollo de talento',
    'corporate knowledge': 'Conocimiento corporativo',
    'governance, advisory, legal, finance': 'gobernanza, asesoría, legal, finanzas',
    'strategies & services': 'Estrategias y servicios',
    'execution across tech, marketing, operations': 'ejecución en tecnología, marketing, operaciones',
    'function': 'Function',
    'role': 'Role',
    'architect': 'Arquitecto',
    'designs frameworks and structures for growth.': 'Diseña marcos y estructuras para el crecimiento.',
    'integrator': 'Integrador',
    'aligns and connects multiple divisions and ventures.': 'Alinea y conecta múltiples divisiones y empresas.',
    'guardian': 'Guardián',
    'protects brand integrity, legal foundations, and vision.': 'Protege la integridad de la marca, los fundamentos legales y la visión.',
    'empowerer': 'Empoderador',
    'provides tools, capital, systems, and strategic leverage.': 'Proporciona herramientas, capital, sistemas y apalancamiento estratégico.',

    // BRIDGEROCKS WORLD SERVICES
    'Know more': 'Saber más',
    'Corporate Structuring & Incorporation': 'Estructuración corporativa y constitución de empresas',
    'Multinational setups, tax optimization': 'Estructuras multinacionales, optimización fiscal',
    'Legal Entity Formation & Compliance': 'Constitución y cumplimiento de entidades legales',
    'Business Modeling & Go-to-Market Strategy': 'Modelado empresarial y estrategia de lanzamiento al mercado',
    'Board Governance Setup & Advisory': 'Configuración y asesoría de gobierno corporativo',
    'Risk Management & Liability Protection': 'Gestión de riesgos y protección de responsabilidad',
    'Exit Planning & Strategic Partnerships': 'Planificación de salida y alianzas estratégicas',
    'Succession Planning for Founders': 'Planificación de sucesión para fundadores',
    'Our services': 'Nuestros servicios',
    'FRACTIONAL CXO SERVICDES': 'Servicios de CXO fraccional',
    'CFO, CMO, CTO': 'CFO, CMO, CTO',
    'BACK OFFICE-AS-A-SERVICE': 'Back office como servicio',
    'Admin, HR, Payroll, Procurement': 'Administración, recursos humanos, nómina, adquisiciones',
    'ACCOUNTING & BOOK KEEPING': 'Contabilidad y mantenimiento de libros contables',
    'LEGAL SUPPORT': 'Asistencia legal',
    'IP, contracts, licensing': 'Propiedad intelectual, contratos, licencias',
    'TECH DEVELOPMENT': 'Desarrollo tecnológico',
    'Via IT + software partners': 'A través de socios de TI y software',
    'BRAND STRATEGY & DESIGN EXECUTION': 'Estrategia de marca y ejecución de diseño',
    'DIGITAL MARKETING & GROWTH OPS': 'Marketing digital y operaciones de crecimiento',
    'CRM & SALES INFRASTRUCTURE SETUP': 'Configuración de CRM e infraestructura de ventas',
    'REGULATORY & LICENSING COMPLIANCE': 'Cumplimiento normativo y de licencias',
    'By sector and geography': 'Por sector y geografía',
    'OUR SERVICES': 'NUESTROS SERVICIOS',
    'EQUITY & DEBT CAPITAL ADVISORY': 'Asesoría en capital accionario y deuda',
    'FUNDRAISING STRATEGY (SEED TO SERIES C)': 'Estrategia de recaudación de fondos (de semilla a serie C)',
    'INVESTOR PITCH COACHING & DEAL STRUCTURING': 'Preparación de presentaciones para inversores y estructuración de operaciones',
    'FINANCIAL MODELING & VALUATION': 'Modelado financiero y valoración',
    'CAP TABLE DESIGN & SHAREHOLDER AGREEMENTS': 'Diseño de tabla de capitalización y acuerdos entre accionistas',
    'ACCESS TO INVESTORS, FUNDS, AND ANGEL NETWORKS': 'Acceso a inversores, fondos y redes de inversores ángeles',
    'PROJECT-BASED INVESTMENT VEHICLES': 'Vehículos de inversión basados en proyectos',
    '(e.g. SPVs)': '(por ejemplo, SPV)',
    'Advisory': 'Asesoría',


    // Properties
    'ABOUT REYROCK PROPERTIES': 'ACERCA DE REYROCK PROPERTIES',
    'Strategic Advisory': 'Asesoría estratégica',
    'Operation/Production': 'Operación/Producción',
    'Portfolio': 'Portafolio',
    'Talents': 'Talentos'

}

export { translation };
